export default __webpack_public_path__ + "static/media/2.c7d57418.jpg";